import React from 'react';
import LandingPage from './components/LandingPage'; // Ajuste o caminho se necessário
import './App.css'; // Se você tiver estilos globais adicionais
import './index.css'; // Para garantir que as diretivas do Tailwind sejam carregadas

function App() {
  return (
    <LandingPage />
  );
}

export default App;